export default __webpack_public_path__ + "assets/zimbabwe-flag.png";